<template>
  <div>
    <v-container>

       <v-row>
        <v-expansion-panels multiple v-model="panel" v-if="client == '128' || client =='LAMCOR'">
          <v-expansion-panel>
            <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
            <v-expansion-panel-content>
              <template>
                <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding" > 
                  <pay-loc-selection
                    :show-dense="false"
                    :headers="payLocHeaders"
                    :show-select="true"
                    v-model="payLoc"
                    :by-user="true"
                  ></pay-loc-selection>
                </v-col>
                
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Employee List</v-expansion-panel-header>
            <v-expansion-panel-content>
               <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding"> 
                <employee-selection :show-dense="false" :show-select="true" v-model="employees" :pay-loc="payLoc"></employee-selection>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
        </v-expansion-panels>
       
        
        <template v-else>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :off-remarks="true"
            ></emp-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field label="Name" :value="selectedEmp.desc" :class="classPadding"></v-text-field>
          </v-col>
        </template>
      </v-row>
      <v-row :class="client == '128' || client =='LAMCOR' ? 'mt-4' :  ''">
         <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="signatory"
            label="Signatory"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            :items="letterContents"
            item-text="messageCode"
            :class="classPadding"
            item-value="messageCode"
            v-model="messageCode"
            label="Letter Content"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex"
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");

const EmployeeSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/NewSelection");

const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const API_ENDPOINT_LETTER = "/api/letterContent";

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    signatory: {},
    letterContents: [],
    loading: false,
    messageCode: null,
    employees: [],
    payLoc: [],
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    panel: [0]
  }),
  components: {
    EmpLookup,
    PayLocSelection,
    EmployeeSelection
  },
  computed: {
    ...mapState("other", {
      client: state => state.client
    })
  },
  methods: {
    getLetterContents() {
      this.$axios
        .get(`${API_ENDPOINT_LETTER}`)
        .then(({ data }) => {
          this.letterContents = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    exportReport() {
      this.loading = true;
      var data = {
        EmpCode: this.selectedEmp.code,
        SignatoryEmpCode: this.signatory.code,
        MessageCode: this.messageCode
      };

       var url = `${API_ENDPOINT}/coe-separated`

      if(this.employees.length > 0){
        data = {
          EmpCodes: this.employees,
          EmpCode2: this.signatory.code,
          MessageCode: this.messageCode
        };

        url = `${API_ENDPOINT}/coe-separated-multiple`
      }

      this.$axios
        .post(`${url}`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getLetterContents();
  }
};
</script>